module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.productionAdminEdit && !_vm.qaqcEnabled && _vm.isShpoCr) ? _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("SHPO CR Notes")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'form-inline': _vm.qaqcEnabled
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.culturalResourceRecording.shpoCrRecordingNotes),
      expression: "culturalResourceRecording.shpoCrRecordingNotes"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4"
    },
    domProps: {
      "value": (_vm.culturalResourceRecording.shpoCrRecordingNotes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.culturalResourceRecording, "shpoCrRecordingNotes", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [(_vm.isNormalization) ? [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Add Site Form Link to Notes")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOtherCrrId),
      expression: "selectedOtherCrrId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedOtherCrrId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.otherCrrList), function(crr) {
    return _c('option', {
      key: crr.culturalResourceRecordingId,
      domProps: {
        "value": crr.culturalResourceRecordingId
      }
    }, [_vm._v("\r\n                            " + _vm._s(crr.smithsonianNumber + " - " + crr.culturalResourceRecordingId) + "\r\n                        ")])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin": "5px"
    },
    on: {
      "click": _vm.insertCrrLinkToNotes
    }
  }, [_vm._v("Insert")])])] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (!_vm.productionAdminEdit && !_vm.qaqcEnabled) ? _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Recorded By")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'form-inline': _vm.qaqcEnabled
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.culturalResourceRecording.recordedBy),
      expression: "culturalResourceRecording.recordedBy"
    }],
    staticClass: "form-control",
    style: (_vm.qaqcInputStype),
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.culturalResourceRecording.recordedBy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.culturalResourceRecording, "recordedBy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Field Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'form-inline': _vm.qaqcEnabled
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "MM/dd/yyyy",
      "placeholder": "Select Date",
      "disabled": _vm.formDisabled
    },
    model: {
      value: (_vm.culturalResourceRecording.fieldDate),
      callback: function($$v) {
        _vm.$set(_vm.culturalResourceRecording, "fieldDate", $$v)
      },
      expression: "culturalResourceRecording.fieldDate"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.culturalResourceRecording.fieldDate),
      expression: "culturalResourceRecording.fieldDate"
    }],
    attrs: {
      "name": "fieldDate",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.culturalResourceRecording.fieldDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.culturalResourceRecording, "fieldDate", $event.target.value)
      }
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Recording Organization")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.recordingOrganization))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Smithsonian Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-label"
  }, [(!_vm.productionAdminEdit) ? _c('a', {
    on: {
      "click": _vm.goProduction
    }
  }, [_vm._v(_vm._s(_vm.culturalResource.smithsonianNumber))]) : _c('span', [_vm._v(_vm._s(_vm.culturalResource.smithsonianNumber))]), _vm._v(" "), (_vm.isMigrated) ? _c('div', {
    staticClass: "pull-right"
  }, [_vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Record Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_vm._v("\r\n                " + _vm._s(_vm.culturalResourceRecording.recordingTypeDescription) + "\r\n                "), (_vm.productionAdminEdit) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label text-label",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "for": "isNoFormOnFile"
    }
  }, [_vm._v("No Form on File")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.culturalResource.isNoFormOnFile),
      expression: "culturalResource.isNoFormOnFile"
    }],
    staticClass: "form-check-input",
    staticStyle: {
      "width": "15px",
      "height": "15px"
    },
    attrs: {
      "type": "checkbox",
      "id": "isNoFormOnFile"
    },
    domProps: {
      "checked": Array.isArray(_vm.culturalResource.isNoFormOnFile) ? _vm._i(_vm.culturalResource.isNoFormOnFile, null) > -1 : (_vm.culturalResource.isNoFormOnFile)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.culturalResource.isNoFormOnFile,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.culturalResource.isNoFormOnFile = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.culturalResource.isNoFormOnFile = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.culturalResource, "isNoFormOnFile", $$c)
        }
      }
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Site Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'form-inline': _vm.qaqcEnabled
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.culturalResourceRecording.siteName),
      expression: "culturalResourceRecording.siteName"
    }],
    staticClass: "form-control",
    style: (_vm.qaqcInputStype),
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.culturalResourceRecording.siteName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.culturalResourceRecording, "siteName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'siteName',
      "hasAppend": false
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Member of District or Linear")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "text-label"
  }, [_vm._v(_vm._s(_vm.culturalResource.grouping) + "\r\n                "), _c('a', {
    staticClass: "fa fa-edit",
    class: {
      'disabled-link': _vm.formDisabled
    },
    staticStyle: {
      "margin-left": "10px",
      "font-size": "18px"
    },
    on: {
      "click": function($event) {
        _vm.goCulturalResourceGroup()
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("\r\n                Property Category\r\n            ")]), _vm._v(" "), (!(_vm.productionAdminEdit || _vm.isFirstOrFullRecord || _vm.qaqcEnabled)) ? _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_vm._v("\r\n                " + _vm._s(_vm.culturalResourceRecording.siteTypeDescription) + "\r\n            ")]) : _c('div', {
    staticClass: "col-md-4",
    class: {
      'form-inline': _vm.qaqcEnabled
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.culturalResourceRecording.siteTypeId),
      expression: "culturalResourceRecording.siteTypeId"
    }],
    staticClass: "form-control",
    style: (_vm.qaqcInputStype),
    attrs: {
      "name": "siteTypeId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.culturalResourceRecording, "siteTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.siteTypeList), function(siteType) {
    return _c('option', {
      key: siteType.siteTypeId,
      domProps: {
        "value": siteType.siteTypeId
      }
    }, [_vm._v("\r\n                        " + _vm._s(siteType.description) + "\r\n                    ")])
  })], 2), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'siteTypeId',
      "hasAppend": false
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("\r\n                Time Period\r\n            ")]), _vm._v(" "), (!(_vm.productionAdminEdit || _vm.isFirstOrFullRecord || _vm.qaqcEnabled)) ? _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_vm._v("\r\n                " + _vm._s(_vm.culturalResourceRecording.timePeriodDescription) + "\r\n            ")]) : _c('div', {
    staticClass: "col-md-4",
    class: {
      'form-inline': _vm.qaqcEnabled
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.culturalResourceRecording.timePeriodId),
      expression: "culturalResourceRecording.timePeriodId"
    }],
    staticClass: "form-control",
    style: (_vm.qaqcInputStype),
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.culturalResourceRecording, "timePeriodId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.timePeriodList), function(period) {
    return _c('option', {
      key: period.id,
      domProps: {
        "value": period.id
      }
    }, [_vm._v(_vm._s(period.description))])
  })], 2), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'timePeriodId',
      "hasAppend": false
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('div', {
    staticClass: "col-md-4",
    class: {
      'form-inline': _vm.qaqcEnabled
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin": "5px"
    },
    on: {
      "click": function($event) {
        _vm.$refs['secondaryCategoryModal'].open()
      }
    }
  }, [_vm._v("Secondary Categories")]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'secondarySiteTypeList',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('modal', {
    ref: "secondaryCategoryModal"
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Secondary Property Categories")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('checkboxPanel', {
    ref: "siteTypePanel",
    attrs: {
      "readonly": !(_vm.productionAdminEdit || _vm.isFirstOrFullRecord || _vm.qaqcEnabled),
      "numColumns": 4,
      "lookupList": _vm.siteTypeList,
      "fieldName": 'siteTypeId',
      "suffix": _vm.qaqcEnabled ? 'Qaqc' : '',
      "name": "siteTypeCB"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "name": "buttonCancel"
    },
    on: {
      "click": function($event) {
        _vm.$refs['secondaryCategoryModal'].close()
      }
    }
  }, [_vm._v("Close")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'form-inline': _vm.qaqcEnabled
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin": "5px"
    },
    on: {
      "click": function($event) {
        _vm.$refs['secondaryTimePeriodModal'].open()
      }
    }
  }, [_vm._v("Secondary Time Periods")]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'secondaryTimePeriodList',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('modal', {
    ref: "secondaryTimePeriodModal"
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Secondary Time Periods")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('checkboxPanel', {
    ref: "timePeriodPanel",
    attrs: {
      "readonly": !(_vm.productionAdminEdit || _vm.isFirstOrFullRecord || _vm.qaqcEnabled),
      "numColumns": 4,
      "lookupList": _vm.timePeriodList,
      "fieldName": 'id',
      "suffix": _vm.qaqcEnabled ? 'Qaqc' : '',
      "name": "timePeriodCB"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "name": "buttonCancel"
    },
    on: {
      "click": function($event) {
        _vm.$refs['secondaryTimePeriodModal'].close()
      }
    }
  }, [_vm._v("Close")])])])])], 1)]), _vm._v(" "), (_vm.productionAdminEdit) ? _c('div', {
    staticClass: "form-group"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Is Confidential")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.culturalResource.isConfidential),
      expression: "culturalResource.isConfidential"
    }],
    staticClass: "form-check-input",
    staticStyle: {
      "width": "15px",
      "height": "15px"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.culturalResource.isConfidential) ? _vm._i(_vm.culturalResource.isConfidential, null) > -1 : (_vm.culturalResource.isConfidential)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.culturalResource.isConfidential,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.culturalResource.isConfidential = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.culturalResource.isConfidential = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.culturalResource, "isConfidential", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Is Inactive")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.culturalResource.isInactive),
      expression: "culturalResource.isInactive"
    }],
    staticClass: "form-check-input",
    staticStyle: {
      "width": "15px",
      "height": "15px"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.culturalResource.isInactive) ? _vm._i(_vm.culturalResource.isInactive, null) > -1 : (_vm.culturalResource.isInactive)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.culturalResource.isInactive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.culturalResource.isInactive = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.culturalResource.isInactive = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.culturalResource, "isInactive", $$c)
        }
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.qaqcEnabled || _vm.productionAdminEdit) ? _c('div', {
    staticClass: "form-group"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [(_vm.culturalResourceRecording.siteTypeId === _vm.propertyTypeEnum.District) ? _c('div', [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("District Ownership Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.culturalResourceRecording.districtOwnershipTypeId),
      expression: "culturalResourceRecording.districtOwnershipTypeId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.culturalResourceRecording, "districtOwnershipTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.districtOwnershipTypeList), function(type) {
    return _c('option', {
      key: type.id,
      domProps: {
        "value": type.id
      }
    }, [_vm._v("\r\n                            " + _vm._s(type.description) + "\r\n                        ")])
  })], 2), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'districtOwnershipTypeId',
      "hasAppend": false
    }
  }) : _vm._e()], 1)]) : _vm._e()])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [(_vm.culturalResourceRecording.siteTypeId === _vm.propertyTypeEnum.District) ? _c('div', [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("District Ownership Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_vm._v("\r\n                    " + _vm._s((_vm.districtOwnershipTypeList.find(function (x) { return x.id === _vm.culturalResourceRecording.districtOwnershipTypeId; }) || {
    description: 'None'
  }).description) + "\r\n                ")])]) : _vm._e()])]), _vm._v(" "), (!_vm.productionAdminEdit && !_vm.qaqcEnabled) ? _c('div', {
    staticClass: "form-group"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Attachments")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-label"
  }, [_vm._v(_vm._s(_vm.attachmentString))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('landOwnership', {
    attrs: {
      "parentId": _vm.parentId,
      "source": _vm.source,
      "formDisabled": _vm.formDisabled
    }
  }), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'landownership',
      "hasAppend": true
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Identifiers")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 text-label"
  }, [_c('table', {
    staticClass: "table",
    staticStyle: {}
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.culturalResourceIdentifiers), function(identifier) {
    return _c('tr', {
      key: identifier.index
    }, [_c('td', [_c('a', {
      staticClass: "fa fa-edit",
      class: {
        'disabled-link': _vm.formDisabled
      },
      staticStyle: {
        "font-size": "18px"
      },
      on: {
        "click": function($event) {
          _vm.showEditIdentifier(identifier.culturalResourceIdentifierId)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(identifier.identifierTypeDescription))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(identifier.parentDescription))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(identifier.identifier))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "fa fa-ban",
      class: {
        'disabled-link': _vm.formDisabled
      },
      staticStyle: {
        "font-size": "18px"
      },
      on: {
        "click": function($event) {
          _vm.deleteIdentifier(identifier.culturalResourceIdentifierId)
        }
      }
    })])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formDisabled),
      expression: "!formDisabled"
    }],
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.showAddIdentifier()
      }
    }
  }, [_vm._v("Add Identifier")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'identifiers',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('modal', {
    ref: "addIdentifierModal"
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Cultural Resource Identifier")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "form form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedIdentifierTypeId),
      expression: "selectedIdentifierTypeId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedIdentifierTypeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.identifierTypeList), function(identifierType) {
    return _c('option', {
      key: identifierType.id,
      domProps: {
        "value": identifierType.id
      }
    }, [_vm._v("\r\n                                                " + _vm._s(identifierType.description) + "\r\n                                            ")])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Owner")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentIdentifier.parentId),
      expression: "currentIdentifier.parentId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentIdentifier, "parentId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.selectedOrgList), function(organization) {
    return _c('option', {
      key: organization.organizationId,
      domProps: {
        "value": organization.organizationId
      }
    }, [_vm._v("\r\n                                                " + _vm._s(organization.description) + "\r\n                                            ")])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Identifier")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentIdentifier.identifier),
      expression: "currentIdentifier.identifier"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentIdentifier.identifier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentIdentifier, "identifier", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "name": "buttonCancel"
    },
    on: {
      "click": function($event) {
        _vm.saveIdentifier()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "name": "buttonCancel"
    },
    on: {
      "click": function($event) {
        _vm.$refs['addIdentifierModal'].close()
      }
    }
  }, [_vm._v(" Cancel ")])])])])], 1)])]), _vm._v(" "), (_vm.isShpoCrApprovingUser || !(_vm.qaqcEnabled || _vm.formDisabled)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.saveOverview
    }
  }, [_vm._v("Save")])])]) : _vm._e(), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldFooter', {
    attrs: {
      "qaqcProgressDto": _vm.qaqcProgressDto,
      "qaqcSelection": _vm.qaqcSelection,
      "sectionName": 'identification',
      "completeSection": _vm.completeSection
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('span', {
    staticClass: "label label-default",
    staticStyle: {
      "color": "#FFFFFF"
    }
  }, [_vm._v("Migrated")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Edit")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Owner")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Delete")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-efc68302"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteForm/IdentificationForm.vue
// module id = 1001
// module chunks = 1